var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 4.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm-2 2.5a.75.75 0 0 1 .75-.75H8a.75.75 0 0 1 .75.75v5.25H10a.75.75 0 1 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.25v-4.5H6.5A.75.75 0 0 1 5.75 7z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export default ForwardRef;